import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelText as _vModelText, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = { class: "card-title align-items-center" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_4 = {
  key: 0,
  class: "card-label fw-bold fs-3"
}
const _hoisted_5 = {
  key: 1,
  class: "card-label fw-bold fs-3"
}
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "seq-period-filter mb-0" }
const _hoisted_8 = {
  key: 0,
  class: "seq-period-filter__field"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "GC Type", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("option", { value: "PR" }, "Product GC", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: "TV" }, "PGI", -1)
const _hoisted_12 = { class: "seq-period-filter__field" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "Quantity", -1)
const _hoisted_14 = { class: "card-header border-0 pt-5" }
const _hoisted_15 = { class: "card-title align-items-center" }
const _hoisted_16 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Redeem Sodexo", -1)
const _hoisted_18 = { class: "card-body py-3" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-8 mb-6" }, [
  /*#__PURE__*/_createTextVNode(" Sodexo Releasing Branch (Sodexo GC will be released "),
  /*#__PURE__*/_createVNode("span", { class: "seq-badge seq-badge--success" }, "6 working days"),
  /*#__PURE__*/_createTextVNode(" after you redeem in the branch you specified.) ")
], -1)
const _hoisted_20 = { class: "row g-6 mb-6" }
const _hoisted_21 = { class: "col-md-6 col-xl-4" }
const _hoisted_22 = {
  key: 0,
  class: "seq-period-filter mb-0"
}
const _hoisted_23 = { class: "seq-period-filter__field seq-period-filter__field--month" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "Quantity", -1)
const _hoisted_25 = { class: "seq-period-filter__field seq-period-filter__field--month" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { class: "seq-period-filter__label" }, "Branch", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("option", { value: "" }, "Select Branch", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_StatCard = _resolveComponent("StatCard")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("h3", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Box2.svg" })
          ]),
          (_ctx.gc_type == 'PR')
            ? (_openBlock(), _createBlock("span", _hoisted_4, "Redeem Product GC"))
            : (_openBlock(), _createBlock("span", _hoisted_5, "Redeem PGI"))
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          (_ctx.isallowedTravelGCRedeem)
            ? (_openBlock(), _createBlock("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createVNode("select", {
                  class: "seq-period-filter__select",
                  id: "gc_type",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.gc_type = $event))
                }, [
                  _hoisted_10,
                  _hoisted_11
                ], 512), [
                  [_vModelSelect, _ctx.gc_type]
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_12, [
            _hoisted_13,
            _withDirectives(_createVNode("input", {
              type: "text",
              class: "seq-period-filter__input",
              placeholder: "Enter quantity here",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.gc_redeem = $event))
            }, null, 512), [
              [_vModelText, _ctx.gc_redeem]
            ])
          ]),
          _createVNode("button", {
            type: "button",
            class: "btn btn-seq-blue",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gc_redeem = '0'))
          }, " Cancel "),
          (_ctx.gcmodeldata.isEnabledCountryGCRedeemButton === true)
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-seq-green",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.processGCRedeem()))
              }, " Redeem "))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card seq-card mt-5"]
    }, [
      _createVNode("div", _hoisted_14, [
        _createVNode("h3", _hoisted_15, [
          _createVNode("span", _hoisted_16, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Shopping/Ticket.svg" })
          ]),
          _hoisted_17
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _hoisted_19,
        _withDirectives(_createVNode("div", _hoisted_20, [
          _createVNode("div", _hoisted_21, [
            _createVNode(_component_StatCard, {
              label: `Available SODEXO for User ID (${_ctx.usid})`,
              icon: "media/icons/duotone/Shopping/Wallet2.svg",
              value: _ctx.availableSodexo,
              "currency-symbol": "",
              period: "",
              decimals: 0
            }, null, 8, ["label", "value"])
          ])
        ], 512), [
          [_vShow, !_ctx.loadingBalance]
        ]),
        (_ctx.gcmodeldata.isallowedSodexo)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createVNode("input", {
                  type: "number",
                  min: "0",
                  step: "1",
                  inputmode: "numeric",
                  class: "seq-period-filter__input",
                  placeholder: "Enter quantity here",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sodexo_quantity = $event)),
                  onKeydown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.blockNonNumericKey && _ctx.blockNonNumericKey(...args)))
                }, null, 544), [
                  [
                    _vModelText,
                    _ctx.sodexo_quantity,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createVNode("select", {
                  class: "seq-period-filter__select",
                  id: "destination",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.branchcode_selected = $event))
                }, [
                  _hoisted_27,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.branches, (item, index) => {
                    return (_openBlock(), _createBlock("option", {
                      key: index,
                      value: item.branch_code
                    }, _toDisplayString(item.description), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.branchcode_selected]
                ])
              ]),
              _createVNode("button", {
                type: "button",
                class: "btn btn-seq-blue",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sodexo_quantity = 0))
              }, " Cancel "),
              (_ctx.gcmodeldata.isEnabledCountryGCRedeemButton === true && _ctx.isEnabledCountryGCRedeemButton)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-seq-green",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.process_sodexoredeem()))
                  }, " Redeem "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2), [
      [_vShow, !_ctx.loading && _ctx.gcmodeldata.countryCode == 0]
    ])
  ], 64))
}